import { render, staticRenderFns } from "./AppUpdaterComponent.vue?vue&type=template&id=2f6d8766&scoped=true"
import script from "./AppUpdaterComponent.vue?vue&type=script&lang=js"
export * from "./AppUpdaterComponent.vue?vue&type=script&lang=js"
import style0 from "./AppUpdaterComponent.vue?vue&type=style&index=0&id=2f6d8766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6d8766",
  null
  
)

export default component.exports